import React, { Component } from 'react';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import Home from './pages/Home';
import About from './pages/About';
import Contact from './pages/Contact';
import Bio from './pages/Bio';
import Book from './pages/Book';
import News from './pages/News';

export default class App extends Component {
  render() {
    return (
      <Router>
        <div>
          <Route exact path="/" component={Home}/>
          <Route path="/about" component={About}/>
          <Route path="/contact" component={Contact}/>
          <Route path='/bio' component={Bio}/>
          <Route path='/book' component={Book}/>
          <Route path='/news' component={News}/>
          <Route path='/test' component={() => window.open('https://www.facebook.com/sharer/sharer.php?u=&amp;t=')}/>
          <Route path='/twitter' component={() => window.open('https://twitter.com/intent/tweet?source=&amp;text=:%20')}/>
          <Route path='/amazon' component={() => window.open('https://www.amazon.com/Cry-Rain-Memoir-Melineh-Petrosian/dp/1632134926')}/>
          <Route path='/barnesAndNobel' component={() => window.open('https://www.barnesandnoble.com/w/cry-for-rain-melineh-petrosian/1129147588?ean=9781632134929')}/>

          

        </div>
      </Router>
    );
  }
}

